<template>
  <div>
    <!--<b-button v-b-modal.modal-1>Launch demo modal -> {{ formData.commProductsCount }}</b-button>-->
    <!-- <b-button @click="handleShowOrdersBasket()">Launch demo modal {{ formData.commProductsCount }}</b-button> -->
    <b-button @click="handleShowOrdersBasket()" :style="cmpnStyle">
      <!-- <i class="mdi mdi-cart"></i> -->
      <b-icon icon="cart4"></b-icon>
      Warenkorb
      <b-badge variant="light">{{ formData.commProductsCount }}</b-badge>
    </b-button>

    <b-modal ref="basketModalRef" id="basket-modal" title="Order basket">
      <!-- <p class="my-4">Hello from order basket! {{ formData.basketCPDetails }}</p>
      <p class="my-4">Hello from order basket! {{ formData.commProductsCount }}</p> -->
      <div>
        <b-row style="background: lightblue;">
          <b-col></b-col>
          <b-col>Article</b-col>
          <b-col>Price</b-col>
          <b-col>Amount</b-col>
          <b-col>Action</b-col>
        </b-row>
      </div>
      <div v-for="cp in formData.basketCPDetails" :key="cp.key">
        <b-row style="margin-top: 4px;">
          <b-col><b-img :src="cp.cpDetail.fragments.imgSrc" fluid></b-img></b-col>
          <b-col>{{ cp.cpDetail.fragments.title }}</b-col>
          <b-col>{{ cp.cpDetail.fragments.price }}</b-col>
          <b-col style="border-bottom: solid 1px;">{{ cp.cpAmount }}</b-col>
          <b-col>
            <b-container>
              <b-button size="sm" @click="handleBasketCPDetailsChangeAmount(cp.cpKey, 1)"><!--i class="mdi mdi-plus"></i--><b-icon icon="plus"></b-icon></b-button>
              <b-button size="sm" @click="handleBasketCPDetailsChangeAmount(cp.cpKey, -1)"><!--i class="mdi mdi-minus"></i--><b-icon icon="dash"></b-icon></b-button>
              <b-button size="sm" @click="handleBasketCPDetailsChangeAmount(cp.cpKey, cp.cpAmount*(-1))"><!--i class="mdi mdi-delete"></i--><b-icon icon="trash"></b-icon></b-button>
            </b-container>
          </b-col>
        </b-row>
        <b-row style="border-bottom: solid 1px;">
          <b-col></b-col>
          <b-col></b-col>
          <b-col>Subtotal:</b-col>
          <b-col>{{ cp.cpDetail.fragments.price*cp.cpAmount }}</b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <div>
        <b-row style="border-bottom: solid 1px;">
          <b-col></b-col>
          <b-col></b-col>
          <b-col>Total:</b-col>
          <b-col>{{ basketTotal }}</b-col>
          <b-col></b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button @click="handleHideOrdersBasket()">Weiter Einkaufen</b-button>
        <b-button @click="handleShowOrderForm()">Bestellen</b-button>
      </template>
    </b-modal>

    <b-modal ref="deliveryDetailsModalRef" id="order-modal" title="Angaben zur Lieferung">
      <label for="input-name">Name *: </label>
      <b-form-input
        id="input-name"
        v-model="formData.deliveryDetails.name"
        type="text"
        required
        :state="validateOrderName"
        aria-aria-describedby="input-name-feedback"
        placeholder="Nachname"/>
      <b-form-invalid-feedback id="input-name-feedback">Mindestens 3 Buchstaben</b-form-invalid-feedback>
      <label for="input-street">Straße und Hausnummer *: </label>
      <b-form-input
        id="input-street"
        v-model="formData.deliveryDetails.street"
        type="text"
        required
        :state="validateOrderStreet"
        placeholder="Straße und Hausnummer"/>
      <label for="input-zip">PLZ *: </label>
      <b-form-input
        id="input-zip"
        v-model="formData.deliveryDetails.zip"
        type="number"
        required
        :state="validateOrderZip"
        placeholder="Postleitzahl"/>
      <label for="input-city">Ort *: </label>
      <b-form-input
        id="input-city"
        v-model="formData.deliveryDetails.city"
        type="text"
        required
        :state="validateOrderCity"
        placeholder="Ort"/>
      <label for="input-email">eMail *: </label>
      <b-form-input
        id="input-email"
        v-model="formData.deliveryDetails.email"
        type="email"
        required
        :state="validateOrderEmail"
        placeholder="eMail"/>
      <b-form-checkbox
        id="input-agb"
        v-model="formData.deliveryDetails.agb"
        name="agb"
        required
        :state="validateAgb">
        Ich erkläre mich mit den <a href="/legal/agb">AGB</a> einverstanden
      </b-form-checkbox>
      <b-form-checkbox
        v-if="age18"
        id="input-age18"
        v-model="formData.deliveryDetails.age18"
        name="age18"
        required
        :state="validateAge18">
        Ich bin über 18 Jahre alt
      </b-form-checkbox>
      <label for="textarea-notice">Anmerkungen: </label>
      <b-form-textarea
        id="textarea-notice"
        v-model="formData.deliveryDetails.notice"
        type="text"
        rows="2"
        max-rows="4"
        no-resize
        placeholder="Anmerkungen"/>
      <template v-slot:modal-footer>
        <b-button @click="handleHideDeliveryDetails()">Weiter Einkaufen</b-button>
        <b-button @click="handleSendOrder()">Bestellen</b-button>
      </template>
    </b-modal>

    <b-modal ref="orderSuccessModalRef" id="order-success" title="Bestellung Information!" ok-only>
      <p v-if="orderSuccSent">
        Ihre Bestellung wurde erfolgreich versendet!
      </p>
      <p v-else style="color: red;">
        Es ist ein fehler aufgetretten bei versenden ihrer Bestellung! Bitte versuchen Sie es erneut später!
      </p>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import * as events from '@/events'
// import Vue from 'vue/dist/vue.js'
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
//
// Vue.use(BootstrapVue)

function _getDefaultFormData () {
  return {
    basketCPDetails: [],
    commProductsCount: 0,
    deliveryDetails: {
      name: null,
      street: null,
      zip: null,
      city: null,
      email: null,
      agb: false,
      age18: false,
      notife: ''
    }
  }
}

export default {
  name: 'order-basket-btn',
  version: '0.0.2',
  props: {
    instKey: {
      type: String,
      required: true
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    age18: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      info: '... loading content!',
      loaded: false,
      basketKey: null,
      orderSuccSent: true,
      cmpnStyle: {
        backgroundColor: this.bgColor
      },
      formData: _getDefaultFormData()
    }
  },
  /* ----- vuejs hooks ----- */
  async mounted () {
    this.loaded = false
    console.log('TRACE-REMOVE: OrderBasketBtn.mounted called!')
    try {
      let _glapiResp
      const _ordersBasket = JSON.parse(sessionStorage.getItem('ordersBasket'))
      if (_ordersBasket) { // TODO: if not expired to be added
        console.log('TRACE-REMOVE: OrderBasketBtn.mounted: _ordersBasket is: ', _ordersBasket)
        try {
          _glapiResp = await axios.get(config.glapiBaseUri + '/orders/' + this.instKey +
            '/basket/' + _ordersBasket['key'])
        } catch (e) {
          console.log('WARN-REMOVE: OrderBasketBtn.mounted: Not able to obtain the basket: ', _ordersBasket)
        }
      }
      if (!_glapiResp){
        _glapiResp = await axios.get(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket')
      }
      console.log('TRACE-REMOVE: OrderBasketBtn.mounted: _resp is: ', _glapiResp)
      if ('success' === _glapiResp.data.status) {
        console.log('TRACE-REMOVE: OrderBasketBtn.mounted: success!!!')
        let _glapiOrdersBasket = _glapiResp.data.payload
        this.formData.commProductsCount = _glapiOrdersBasket.commProductsCount || 0
        this.basketKey = _glapiOrdersBasket['key']
        sessionStorage.setItem('ordersBasket', JSON.stringify(_glapiOrdersBasket))
      } else {
        throw new Error('Error by server processing!')
      }
      this.loaded = true
    } catch (e) {
      this.loaded = false
    }
  }, // mounted
  created () {
    console.log('TRACE-REMOVE: OrderBasketBtn.created!')
    events.bus.onGlobal(events.types.orders.GLGE_ADD_2_BASKET, e => this.handleAdd2Basket(e))
  }, // created
  destroyed () {
    console.log('TRACE-REMOVE: OrderBasketBtn.destroyed!')
    events.bus.offGlobal(events.types.orders.GLGE_ADD_2_BASKET, e => this.handleAdd2Basket(e))
  }, // destroyed
  /* ----- computed properties ----- */
  computed: {
    basketTotal: function () {
      return this.formData.basketCPDetails.reduce((sum, item) =>
        sum + (item.cpDetail.fragments.price * item.cpAmount), 0)
    }, // basketTotal
    validateOrderName: function () {
      return (this.formData.deliveryDetails.name && this.formData.deliveryDetails.name.length > 3) ? true : false
    }, // validateOrderName
    validateOrderStreet: function () {
      return (this.formData.deliveryDetails.street && this.formData.deliveryDetails.street.length > 3) ? true : false
    }, // validateOrderStreet
    validateOrderZip: function () {
      return (this.formData.deliveryDetails.zip && this.formData.deliveryDetails.zip.length === 5) ? true : false
    }, // validateOrderZip
    validateOrderCity: function () {
      return (this.formData.deliveryDetails.city && this.formData.deliveryDetails.city.length > 3) ? true : false
    }, // validateOrderCity
    validateOrderEmail: function () {
      // TODO: extend the validation with @ char
      return (this.formData.deliveryDetails.email && this.formData.deliveryDetails.email.length > 3) ? true : false
    }, // validateOrderEmail
    validateAgb: function () {
      return this.formData.deliveryDetails.agb
    }, // validateAgb
    validateAge18: function () {
      return this.formData.deliveryDetails.age18
    } // validateAgb
  }, // computed
  /* ----- private methods ----- */
  methods: {
    async changeCPAmountInBasket (cpKey, amount) {
      try {
        console.log('TRACE-REMOVE: OrderBasketBtn.changeCPAmountInBasket: this.basketKey is: ', this.basketKey)
        const _resp = await axios.post(config.glapiBaseUri + '/orders/basket/' +
          this.basketKey + '/commProduct/' + cpKey + '/' + amount)
        console.log('TRACE-REMOVE: OrderBasketBtn.changeCPAmountInBasket: _resp is: ', _resp)
        if (_resp.data.status === 'success') {
          this.formData.commProductsCount = _resp.data.payload.commProductsCount
        } else {
          throw new Error('Server error!')
        }
      } catch (e) {
        // TODO: consider showing message
        console.error('Error during processing! Exception is: ', e)
      }
    }, // changeCPAmountInBasket
    /* ----- handlers ----- */
    async handleAdd2Basket (ev) {
      console.log('TRACE-REMOVE: OrderBasketBtn.handleAdd2Basket: ev is: ', ev)
      await this.changeCPAmountInBasket(ev.detail.commProduct, ev.detail.amount)
    }, // handleAdd2Basket
    async handleBasketCPDetailsChangeAmount(cpKey, amount) {
      await this.changeCPAmountInBasket(cpKey, amount)
      this.handleShowOrdersBasket()
    },
    // TODO: generalize handleAdd2Basket and removeFromBasket
    async removeFromBasket(cpKey) {
      console.log('TRACE-REMOVE: OrderBasketBtn.removeFromBasket: cpKey is: ', cpKey)
      const _ordersBasket = JSON.parse(sessionStorage.getItem('ordersBasket'))
      try {
        if (!_ordersBasket || !_ordersBasket['key']) {
          throw new Error('Order basket not available!')
        }
        const _resp = await axios.post(config.glapiBaseUri + '/orders/basket/' +
          _ordersBasket['key'] + '/commProduct/' + cpKey + '/' + (-1))
        console.log('TRACE-REMOVE: OrderBasketBtn.handleAdd2Basket: _resp is: ', _resp)
        if (_resp.data.status === 'success') {
          // this.formData.commProducts = _resp.data.payload.commProducts
          this.formData.commProductsCount = _resp.data.payload.commProductsCount
        } else {
          throw new Error('Server error!')
        }
      } catch (e) {
        // TODO: consider showing message
        console.error('Error during processing! Exception is: ', e)
      }
      this.handleShowOrdersBasket()
    }, // removeFromBasket
    async handleShowOrdersBasket () {
      console.log('TRACE-REMOVE: OrderBasketBtn.handleShowOrdersBasket called!')
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket/' + this.basketKey + '/details')
        console.log('TRACE-REMOVE: OrderBasketBtn.handleShowOrdersBasket: _resp is: ', _resp)
        this.formData.basketCPDetails = _resp.data.payload.basketDetails
      } catch (e) {
        console.error('Error processing the basket details! Exception is: ', e);
      }
      // TODO: since it is getting called from other functions consider checking if it is already showing?
      this.$refs.basketModalRef.show()
    }, // handleShowOrdersBasket
    handleHideOrdersBasket () {
      this.$refs.basketModalRef.hide()
    }, // handleHideOrdersBasket
    handleShowOrderForm () {
      console.log('TRACE-REMOVE: OrderBasketBtn.handleShowOrderForm called!')
      this.handleHideOrdersBasket()
      this.$refs.deliveryDetailsModalRef.show()
    }, // handleShowOrderForm
    handleHideDeliveryDetails () {
      this.$refs.deliveryDetailsModalRef.hide()
    }, // handleHideDeliveryDetails
    async handleSendOrder () {
      console.log('TRACE-REMOVE: OrderBasketBtn.handleSendOrder called!')
      if (!this.validateOrderName || !this.validateOrderStreet || !this.validateOrderCity ||
        !this.validateOrderCity || !this.validateOrderZip || !this.validateOrderEmail) {
        console.log('TRACE-REMOVE: OrderBasketBtn.handleSendOrder: order is not valid!')
        return
      }
      try {
        const _resp = await axios.post(config.glapiBaseUri + '/orders/' +
          this.instKey + '/basket/' + this.basketKey, { basketTotal: this.basketTotal,
          deliveryDetails: this.formData.deliveryDetails })
        console.log('TRACE-REMOVE: OrderBasketBtn.handleSendOrder: _resp is: ', _resp)
        // TODO: initialize the new basket
        if (_resp.data.status === 'success') {
          this.formData = _getDefaultFormData()
          this.basketKey = _resp.data.payload.key
          sessionStorage.setItem('ordersBasket', JSON.stringify(_resp.data.payload))
          // this.$refs.orderSuccessModalRef.show()
          this.orderSuccSent = true
        } else {
          throw new Error('Error during processing the order request!')
        }
      } catch (e) {
        console.error('Error processing the basket details! Exception is: ', e)
        this.orderSuccSent = false
      } finally {
        this.$refs.deliveryDetailsModalRef.hide()
        this.$refs.orderSuccessModalRef.show()
      }
    } // handleSendOrder
  } // methods
}
</script>

<style scoped>
/* @import '~@mdi/font/css/materialdesignicons.min.css'; */
@import '~bootstrap/dist/css/bootstrap.css';
/** TODO: check if necessary to reference all the *css files */
/* @import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~bootstrap-vue/dist/bootstrap-vue-icons.css'; */
</style>
